export default "__VITE_ASSET__BhedUVRA__"